import React from "react";
import { useIntl } from "react-intl";
import { Button } from "@folio/stripes/components";
import css from "./ColumnWidthToggle.module.css";
export var ColumnWidthToggle = function (_a) {
    var active = _a.active, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    var label = formatMessage({
        id: "ui-br-legaldeposits.columns.width.button",
    });
    return (React.createElement(Button, { id: "column-width-toggle", buttonStyle: active ? "primary" : "default", marginBottom0: true, className: css.toggle, "aria-pressed": active, "aria-label": label, title: label, onClick: onToggle },
        React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", focusable: "false" },
            React.createElement("path", { d: "M8 2.5v11" }),
            React.createElement("path", { d: "M4.5 8h-3" }),
            React.createElement("path", { d: "M3 6.2 1.2 8 3 9.8" }),
            React.createElement("path", { d: "M11.5 8h3" }),
            React.createElement("path", { d: "M13 6.2 14.8 8 13 9.8" }))));
};
